export default __webpack_public_path__ + "static/product-analytics-cluster-mobile-627b0aac0acc59ef9289b7a95cf43de3.png";